export enum FleetUUIDs {
  ACTransit = '872a8e92-54b5-47b3-90a3-1210ab274d97',
  Barcelona = 'b2d1a097-8e9b-4655-abff-1bcb5c91c898',
  MTA = '4e9c24c6-489f-4f2c-9f10-5ab265c2e3d2',
  MTAReplay = '0ab4225c-da2f-4626-b25c-0f6589fc9fd3',
  MBTA = 'dc65d8cf-4f62-4b59-8a4f-909f9fc9d532',
  MBTAPrePilot = 'c4924bf4-3244-44f2-ba73-563bdf1800e6',
  SacRTBusStopShelter = 'c2170fe9-d566-4e6b-a5d0-1a097d7b24fa',
  SacRTBusStopShelterActivePilot = '0ecade16-4ca5-41ab-9d31-e6d751104168',
  VanTesting = 'e64ba1c4-adb4-45b0-b351-180710e6cc67',
}
